import { FiTrash2 } from 'react-icons/fi'
import { tdClass, thClass } from './WastageReport';
import { formatSalesValue } from '../../../utils/formatUtils';
import React from 'react';

export const NormalCostCenterTable = ({ costcenter, dateGroups, handleDelete }) => {
    const allItems = Object.values(dateGroups).flat();
    const grandAmt = allItems.reduce((s, i) => s + parseFloat(i.price || 0), 0);

    return (
        <div className="mb-6 bg-white rounded-md shadow-md overflow-hidden">
            <div className="px-4 py-2 border-b bg-gray-50 flex justify-between items-center">
                <span className="font-semibold text-gray-700">{costcenter}</span>
                <span className="text-sm text-gray-600 font-medium">
                    {allItems.length} item{allItems.length !== 1 ? 's' : ''}
                </span>
            </div>

            <div className="overflow-auto tiny-scrollbar max-h-[620px]">
                <table className="w-full text-sm text-center">
                    <thead className="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            <th className={thClass}>Item</th>
                            <th className={thClass}>Quantity</th>
                            <th className={thClass}>UOM</th>
                            <th className={thClass}>Rate</th>
                            <th className={thClass}>Amount</th>
                            <th className={thClass}>Actions</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y">
                        {Object.entries(dateGroups).map(([date, items]) => {
                            const dateAmt = items.reduce((s, i) => s + parseFloat(i.price || 0), 0);

                            return (
                                <React.Fragment key={date}>
                                    <tr className="bg-blue-50 border-t border-blue-100">
                                        <td colSpan={6} className="px-3 py-2 text-left text-sm font-semibold text-blue-700 tracking-wide">
                                            {date}
                                        </td>
                                    </tr>

                                    {items.map((item, idx) => {
                                        const qty = parseFloat(item.quantity || 0);
                                        const price = parseFloat(item.price || 0);
                                        const rate = qty > 0 ? price / qty : 0;

                                        return (
                                            <tr key={item.id ?? idx} className="hover:bg-gray-50 transition">
                                                <td className={tdClass}>{item.item_name}</td>
                                                <td className={tdClass}>{qty.toFixed(2)}</td>
                                                <td className={tdClass}>{item.uom}</td>
                                                <td className={tdClass}>{formatSalesValue(rate)}</td>
                                                <td className={`${tdClass} font-medium text-red-600`}>
                                                    {formatSalesValue(price)}
                                                </td>
                                                <td className={tdClass}>
                                                    <button
                                                        onClick={() =>
                                                            handleDelete(item)
                                                        }
                                                        className="p-1.5 rounded border border-gray-300 text-red-600 hover:bg-red-50"
                                                    >
                                                        <FiTrash2 className="h-4 w-4" />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    <tr className="bg-gray-50">
                                        <td colSpan={4} className="px-3 py-2 text-right text-xs font-semibold text-gray-500">
                                            {date} subtotal
                                        </td>
                                        <td className="px-3 py-2 font-semibold text-red-600 text-center">
                                            {formatSalesValue(dateAmt)}
                                        </td>
                                        <td></td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                    </tbody>

                    <tfoot className="bg-gray-100">
                        <tr>
                            <td colSpan={4} className="px-3 py-2 font-semibold text-gray-700 text-right">
                                {costcenter} Total
                            </td>
                            <td className="px-3 py-2 font-semibold text-red-600">
                                {formatSalesValue(grandAmt)}
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export const AggregatedCostCenterTable = ({ costcenter, items }) => {
    const grandAmt = items.reduce((s, i) => s + i.totalAmount, 0);

    return (
        <div className="mb-6 bg-white rounded-md shadow-md overflow-hidden">
            <div className="px-4 py-2 border-b bg-gray-50 flex justify-between items-center">
                <span className="font-semibold text-gray-700">{costcenter}</span>
                <span className="text-sm text-gray-600 font-medium">
                    {items.length} unique item{items.length !== 1 ? 's' : ''}
                </span>
            </div>

            <div className="overflow-auto tiny-scrollbar max-h-[620px]">
                <table className="w-full text-sm text-center">
                    <thead className="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            <th className={thClass}>Item</th>
                            <th className={thClass}>Total Qty</th>
                            <th className={thClass}>UOM</th>
                            <th className={thClass}>Avg Rate</th>
                            <th className={thClass}>Total Amount</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y">
                        {items.map((item, idx) => (
                            <tr key={idx} className="hover:bg-gray-50 transition">
                                <td className={tdClass}>{item.name}</td>
                                <td className={tdClass}>{item.totalQty.toFixed(2)}</td>
                                <td className={tdClass}>{item.uom}</td>
                                <td className={tdClass}>{formatSalesValue(item.avgRate)}</td>
                                <td className={`${tdClass} font-medium text-red-600`}>
                                    {formatSalesValue(item.totalAmount)}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                    <tfoot className="bg-gray-100">
                        <tr>
                            <td colSpan={4} className="px-3 py-2 font-semibold text-gray-700 text-right">
                                {costcenter} Total
                            </td>
                            <td className="px-3 py-2 font-semibold text-red-600">
                                {formatSalesValue(grandAmt)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};
